import type { FaireProductEntity } from "../../entity_types/product";

export const p_andaetr3en: FaireProductEntity = {
  token: "p_andaetr3en",
  type: "product",
  name: "Small Ethically Sourced Labradorite Hearts, Valentines Gift",
  brandToken: "b_fak8czuqg9",
  brandName: "Mandala Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/511b0566cb2ac7820d635074a22da53bd79f2fbe8dae0b411a392734cd30083f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d279fd4012efe6bcb022f1cd9bced2f8f27f9d9424a2018319e469e1b32c5f1c.jpeg",
    "https://cdn.faire.com/fastly/b29a05babeb1f0b65efbdbc8d97a8fffff9cbda2122530d8a991a29bb94b1f1c.png",
  ],
  priceDollars: 5,
  description:
    "Small Labradorite Hearts – Flashy Love Stone | Pocket Heart Crystals\n\nThese shimmering Small Labradorite Hearts may be petite, but they’re full of magic. Each heart reveals flashes of blue, teal, gold, or green as the light moves — that signature labradorite glow that customers can’t resist picking up and turning over in their hands.\n\nSmoothly polished and perfectly sized for pockets, gifting, or crystal bowls, these hearts are especially popular for love-themed displays, self-care moments, and everyday talismans. Labradorite is often associated with intuition, protection, and inner strength, making these hearts both beautiful and meaningful.\n\n✨ Why customers love them\nNatural labradorite carved into heart shapes\nEye-catching flash and iridescence\nSmall, affordable, and perfect for gifting\nSymbolizes protection, intuition, and transformation\n\n💝 Perfect for gifting\nIdeal for Valentine’s Day, Galentine’s Day, friendship gifts, party favors, or self-love rituals. A great add-on item at checkout or for heart-themed crystal displays year-round.\n\n📦 Retailer notes\nEach heart is unique in color and flash intensity\nNatural variations and inclusions are expected\nGreat for crystal bowls, pocket stones, and curated gift sets\n\nKeywords:\nlabradorite heart, small crystal heart, flashy labradorite, love stone, pocket crystal, intuitive stone, protection crystal, crystal gift",
  tags: [],
  msrpDollars: 10,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:37.103Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
